import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'apcam-primeng-no-records',
    templateUrl: './primeng-no-records.component.html',
    styleUrl: './primeng-no-records.component.scss',
    imports: [TranslatePipe],
})
export class PrimeNGNoRecordsComponent {
    @Input({ required: true })
    noLoadedData!: boolean;

    @Input({ required: true })
    colSpan!: number;
}
